import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useCartStore = create(
  persist(
    (set, get) => ({
      items: [],

      addItem: (product) => {
        const { items } = get();
        const key = `${product._id}-${product.size || ''}-${product.color || ''}`;
        const existing = items.find(i => `${i._id}-${i.size || ''}-${i.color || ''}` === key);
        if (existing) {
          set({ items: items.map(i => `${i._id}-${i.size || ''}-${i.color || ''}` === key ? { ...i, quantity: i.quantity + 1 } : i) });
        } else {
          set({ items: [...items, { ...product, quantity: 1 }] });
        }
      },

      removeItem: (id, size, color) => {
        set({ items: get().items.filter(i => !(i._id === id && i.size === size && i.color === color)) });
      },

      updateQuantity: (id, size, color, quantity) => {
        if (quantity < 1) return;
        set({ items: get().items.map(i => i._id === id && i.size === size && i.color === color ? { ...i, quantity } : i) });
      },

      clearCart: () => set({ items: [] }),

      getTotal: () => get().items.reduce((s, i) => s + i.price * i.quantity, 0),
    }),
    { name: 'glitz-cart' }
  )
);
